<section>
  <div class="container" *ngIf="item; else elseTemplate">
    <h2>{{ item?.name?.replace('(T)', '') }}</h2>
    <div class="grid">
      <aside class="col-12 sm:col-3">
        <p-image
          imageClass="image-section mt-3"
          [src]="'/upload/' + item.image_url"
          onError="this.onerror = null; this.src='/assets/not-available.jpeg';"
          alt="section"
          appendTo="body"
          [preview]="true" />
      </aside>

      <article class="col-12 sm:col-9">
        <!-- <h1 class="mt-0">{{ item.name }}</h1> -->
        <!-- <div>
          <i class="ph ph-star"></i>
          <i class="ph ph-star"></i>
          <i class="ph ph-star"></i>
        </div> -->
        <!-- <p-divider></p-divider> -->

        <div class="" [innerHTML]="item.description_large"></div>
        <div class="flex justify-content-start gap-2 mt-4">
          <!-- <p-button
            label="Añadir a reserva"
            (click)="addToCart()"
            severity="primary"
            icon="ph ph-plus" /> -->

          <!-- <p-button
            (onClick)="showDialog()"
            label="Ver política de cancelación"
            [outlined]="false"
            icon="ph ph-file-text"
            class="w-full"
            styleClass="w-full" /> -->
          <!-- <ls-button-atom label="Volver al listado" (click)="back()" /> -->
        </div>
        <!-- <p-divider class="block sm:hidden"></p-divider> -->
      </article>
    </div>

    <!-- <p-divider></p-divider> -->
    <!-- <div class="activities-icons">
      <div class="activities">
        <i class="ph-thin ph-thermometer-hot"></i> <span>Calefacción</span>
      </div>
      <div class="activities">
        <i class="ph-thin ph-bathtub"></i> <span>Bañera</span>
      </div>
      <div class="activities">
        <i class="ph-thin ph-bed"></i> <span>Ropa de cama</span>
      </div>
      <div class="activities">
        <i class="ph-thin ph-towel"></i> <span>Toallas</span>
      </div>
    </div> -->
  </div>

  <ng-template #elseTemplate>
    <div class="flex w-full text-center justify-content-center">
      <p class="text-xl">No hay elementos seleccionados</p>
    </div>
  </ng-template>
</section>

<p-dialog
  header="Política de cancelación"
  [modal]="true"
  [(visible)]="visible"
  [style]="{ width: '50rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">
  <div [innerHTML]="this.policySectionData?.description"></div>
</p-dialog>
